<template>
<div>
    <div v-for="node in nodes" :key="node.id">
        <b-button
            v-b-toggle="'collapse-' + node.id"
            variant="link"
            class="text-decoration-none"
            @click="$emit('toggle', node.id, node.file_type)"
        >
            <b-icon style="transform: rotate(270deg);" :icon="collapsed[node.id] ? 'chevron-left' : 'chevron-down'" />
            <b v-if="selectedFolderId == node.id">{{ node.name }}</b>
            <span v-else>{{ node.name }}</span>
        </b-button>

        <b-collapse :id="'collapse-' + node.id" v-model="collapsed[node.id]" class="ml-3">
            <folder-children
                v-if="node.children && node.children.length"
                :nodes="node.children"
                :selectedFolderId="selectedFolderId"
                :collapsed="collapsed"
                @toggle="$emit('toggle', $event)"
            />
        </b-collapse>
    </div>
</div>
</template>

<script>
export default {
    props: ['nodes', 'collapsed', 'selectedFolderId'],
    name:'folder-children',
};
</script>
